import { getUser } from "../../services/userService";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import "./Commitment.scss";
import CommitmentInfo from "./components/CommitmentInfo/CommitmentInfo";
import OurValues from "./components/OurValues/OurValues";
import TrashInfo from "./components/TrashInfo/TrashInfo";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const Commitment = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.user);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  return (
    <div className="commitment">
      <CommitmentInfo />
      <OurValues />
      <TrashInfo />
    </div>
  );
};

export default Commitment;
